var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"w-full bg-sky-600 py-3"},[_c('div',{staticClass:"max-w-7xl mx-auto px-3 text-left"},[_c('h1',{staticClass:"font-bold text-white text-3xl m-0 p-3"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }